<template>
  <div class="register">
    <!--  表单部分  -->
    <div class="form">
      <div class="forms_mains">
        <div class="forms">
          <el-form ref="UserRegisterLegalEntityDTO1" :model="UserRegisterLegalEntityDTO.user"
            label-position="left" label-width="83px" :rules="rules" style="width:100%">
            <div class="form-item">
              <div class="form-title">账户信息</div>
              <div class="form-input">
                <el-row>
                  <el-col :span="24">
                    <el-form-item class="form_inputs" label="用户名:" prop="account">
                      <el-input placeholder="6~20位字母或‘字母+数字’（不能以数字开头）"
                        v-model="UserRegisterLegalEntityDTO.user.account"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item class="form_inputs" label="设置密码:" prop="pdk">
                      <el-input placeholder="必须是12-30位包含大小写、数字、特殊字符组合" type="password"
                        v-model="UserRegisterLegalEntityDTO.user.pdk"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item class="form_inputs" label="确认密码:" prop="passwordAgain">
                      <el-input placeholder="请保持两次密码输入一致" type="password"
                        v-model="UserRegisterLegalEntityDTO.user.passwordAgain"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-form>
          <el-form ref="UserRegisterLegalEntityDTO2" :model="UserRegisterLegalEntityDTO.legalEntity"
            label-position="left" label-width="82px" :rules="rules" style="width:100%">
            <div class="form-item">
              <div class="form-title">企业信息</div>
              <div class="form-input">
                <el-row>
                  <el-col :span="24">
                    <el-form-item class="form_inputs" label="企业名称" prop="name">
                      <el-input placeholder="请输入完整企业名称"
                        v-model="UserRegisterLegalEntityDTO.legalEntity.name"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item class="form_inputs" label="所属区" prop="districtId">
                      <el-select style="width:100%"
                        v-model="UserRegisterLegalEntityDTO.legalEntity.districtId" clearable
                        placeholder="请选择">
                        <el-option v-for="item in districts" :key="item.id" :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item class="form_inputs double-line" label="统一社会信用代码:" prop="uscCode">
                      <el-input placeholder="请输入统一社会信用代码"
                        v-model="UserRegisterLegalEntityDTO.legalEntity.uscCode"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item class="form_inputs double-line" label="组织机构代码:" prop="orgCode">
                      <el-input placeholder="请输入组织机构代码（非必填）"
                        v-model="UserRegisterLegalEntityDTO.legalEntity.orgCode"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-form>
        </div>
        <el-form ref="UserRegisterLegalEntityDTO3" :model="UserRegisterLegalEntityDTO.legalEntity"
          label-position="left" label-width="82px" :rules="rules">
          <div class="forms">
            <div class="form-item">
              <div class="form-title">联系人信息</div>
              <div class="form-input">
                <div>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item class="form_inputs" label="联系人:" prop="contact">
                        <el-input v-model="UserRegisterLegalEntityDTO.legalEntity.contact">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item class="form_inputs" label="电话:" prop="telephone">
                        <el-input v-model="UserRegisterLegalEntityDTO.legalEntity.telephone">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title visibility">占位</div>
              <div class="form-input">
                <el-row>
                  <el-col :span="24">
                    <el-form-item class="form_inputs" label="手机:" prop="mobilePhone">
                      <el-input v-model="UserRegisterLegalEntityDTO.legalEntity.mobilePhone">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item class="form_inputs" label="邮箱:" prop="email">
                      <el-input v-model="UserRegisterLegalEntityDTO.legalEntity.email"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-form>
        <el-form ref="UserRegisterLegalEntityDTO4" :model="UserRegisterLegalEntityDTO.verifyCode"
          label-position="left" label-width="82px" :rules="rules">
          <div class="forms">
            <div class="form-item">
              <div class="form-input">
                <el-form-item class="form-item" label="验证码:" prop="value">
                  <el-input v-model="UserRegisterLegalEntityDTO.verifyCode.value"
                    style="width: 8rem; float: left"></el-input>
                  <img style="height: 40px; margin-left: 1rem" :src="imgVerifyCode"
                    @click="getVerifyCode">
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <el-form ref="form" :model="UserRegisterLegalEntityDTO" label-position="left"
        label-width="82px" :rules="rules">
        <el-form-item class="form-button" style="text-align: center;margin-top: 50px;">
          <el-button @click="cancel()">取消</el-button>
          <el-button type="primary" @click="submit()">注册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Message } from 'element-ui'
import { district } from '@/utils/dict'

export default {
  name: 'Register',
  data () {
    return {
      rules: {
        account: [
          { required: true, message: '请输入用户名', trigger: ['blur', 'change'] },
          { pattern: /^[a-zA-Z]\w{5,19}$/, message: '6~20位字母或‘字母+数字’（不能以数字开头）' }
        ],
        pdk: [
          { required: true, message: '请输入密码', trigger: ['blur', 'change'] },
          { validator: this.validatePass, trigger: ['blur', 'change'] }
        ],
        passwordAgain: [
          { required: true, message: '请再次输入密码', trigger: ['blur', 'change'] },
          { validator: this.validatePassAgain, trigger: ['blur', 'change'] }
        ],
        value: [
          { required: true, message: '请输入验证码', trigger: ['blur', 'change'] }
        ],
        name: [{ required: true, message: '请输入企业名称', trigger: ['blur', 'change'] }],
        telephone: [
          { required: true, message: '请输入电话', trigger: ['blur', 'change'] },
          { pattern: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/, message: '固话格式有误' }
        ],
        mobilePhone: [
          { required: true, message: '请输入手机', trigger: ['blur', 'change'] },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号格式有误' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: ['blur', 'change'] },
          { pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: '邮箱格式有误' }
        ],
        contact: [
          { required: true, message: '联系人', trigger: ['blur', 'change'] }
        ],
        uscCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: ['blur', 'change'] },
          { pattern: /^[0-9A-Z]{18}$/, message: '统一社会信用代码格式错误' }
        ],
        orgCode: [
          { pattern: /^[0-9A-Z]{8}-[0-9A-Z]$/, message: '组织机构代码格式错误' }
        ],
        districtId: [
          { required: true, message: '请输入所属区', trigger: ['blur', 'change'] }
        ]
      },
      passwordAgain: '',
      imgVerifyCode: `${process.env.VUE_APP_LOADING_IMG}`,
      UserRegisterLegalEntityDTO: {
        legalEntity: {
          contact: '',
          email: '',
          mobilePhone: '',
          name: '',
          orgCode: null,
          telephone: '',
          uscCode: '',
          districtId: ''
        },
        user: {
          account: '',
          pdk: ''
        },
        verifyCode: {
          key: '',
          value: ''
        }
      },
      districts: []
    }
  },
  mounted () {
    this.getVerifyCode()
    this.initDistricts()
  },
  methods: {
    cancel () {
      this.$router.push({ path: '/login' })
    },
    getVerifyCode () {
      const _this = this
      _this.UserRegisterLegalEntityDTO.verifyCode.value = ''
      axios.get(`${process.env.VUE_APP_SERVER_URL}/ucenter/user/front/getVerifyCode`).then(function (response) {
        const res = response.data
        if (res.status !== 200) {
          Message({
            message: res.message,
            type: 'warning'
          })
          return
        }
        _this.imgVerifyCode = 'data:img/png;base64,' + res.data.value
        _this.UserRegisterLegalEntityDTO.verifyCode.key = res.data.key
      })
    },
    initDistricts () {
      // 行政区划列表中存在“北京市”这个历史遗留问题，所以接口中暂且保留，取到数据后再把北京市去掉
      this.districts = district.list()
      if (!this.districts) {
        return
      }
      if (!this.districts.length) {
        return
      }
      if (this.districts[0].id === '110000') {
        this.districts.shift()
      }
    },
    validatePass (rule, value, callback) {
      if (!/^(?![0-9]+$)(?![^0-9]+$)(?![a-zA-Z]+$)(?![^a-zA-Z]+$)(?![a-zA-Z0-9]+$)[a-zA-Z0-9\S]{12,30}$/.test(value)) {
        callback(new Error('必须是12-30位包含大小写、数字、特殊字符组合'))
        return
      }
      if (!this.UserRegisterLegalEntityDTO.user.passwordAgain) {
        callback()
        return
      }
      this.$refs.UserRegisterLegalEntityDTO1.validateField('passwordAgain')
      callback()
    },
    validatePassAgain (rule, value, callback) {
      if (value !== this.UserRegisterLegalEntityDTO.user.pdk) {
        callback(new Error('两次密码不一致'))
        return
      }
      callback()
    },
    submit () {
      const _this = this
      const formName = ['UserRegisterLegalEntityDTO1', 'UserRegisterLegalEntityDTO2', 'UserRegisterLegalEntityDTO3', 'UserRegisterLegalEntityDTO4']
      const validates = (item) => {
        return new Promise((resolve, reject) => {
          if (!this.$refs[item]) {
            resolve()
            return false
          }
          this.$refs[item].validate((valid) => {
            if (valid) {
              resolve()
            } else {
              reject(new Error('验证不对'))
            }
          })
        })
      }
      Promise.all(formName.map(item => validates(item))).then(() => {
        axios.post(`${process.env.VUE_APP_SERVER_URL}/ucenter/user/front/legalEntityRegister`, this.UserRegisterLegalEntityDTO)
          .then(function (response) {
            const res = response.data
            if (res.status !== 200) {
              Message({
                message: res.message,
                type: 'warning'
              })
              _this.getVerifyCode()
              return
            }
            Message({
              message: res.message,
              type: 'success',
              onClose: _this.cancel
            })
          })
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/base.scss';

.register {
  width: 1200px;
  margin: 0 auto;
  .visibility {
    margin-bottom: 30px;
    visibility: hidden;
  }
  .visibilitys {
    margin-bottom: 48px;
  }
  .form {
    width: 1000px;
    margin: 20px auto;
    .forms_mains {
      display: flex;
      flex-direction: column;
      .forms {
        display: flex;
        justify-content: space-between;
        .form-item {
          width: 100%;
          .form-input {
            margin-left: 65px;
            .form_inputs {
              margin-bottom: 20px;
            }
          }

          .form-title {
            @include font_size($font_large);
            font-weight: bold;
            margin-bottom: 10px;
            margin-left: 50px;
          }

          .double-line {
            ::v-deep.el-form-item__label {
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
